import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, HideScrollbar } from '../../global/commonStyle';
import { CSVLink } from 'react-csv';

const TableHeaders = styled.div`
  ${FlexBetween}
  padding: var(--space-20);
  background-color: var(--background-primary);
  border-top: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8) var(--border-radius-8) var(--border-radius-0) var(--border-radius-0);
  border-left: 0.5px solid var(--border-primary);
  border-right: 0.5px solid var(--border-primary);
  ${mobile_xl(css`
    padding: var(--space-16);
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-16);
  `)}
`;
const Left = styled.div`
  display: flex;
  ${mobile_xl(css`
    display: flex;
    width: 100%;
    white-space: nowrap;
    ${HideScrollbar}
  `)}
`;

const Right = styled.div`
  ${AlignCenter}
  position: relative;
  ${mobile_xl(css`
    width: 100%;
    justify-content: flex-end;
  `)}
`;
const Icon = styled.div`
  padding-right: var(--space-12);
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 0.5px solid var(--border-secondary);
  cursor: pointer;
`;

const TitleLast = styled.div`
  color: var(--brand-primary);
  ${Typography.body_md_medium}
  padding-inline:var(--space-12);
  text-decoration: none;
  height: 18px;
  ${mobile_xl(css`
    padding-right: var(--space-0);
  `)}
`;

const CsvLink = styled(CSVLink)`
  text-decoration: none;
`;

export { TableHeaders, Left, Right, Icon, TitleLast, CsvLink };
